import React, { useEffect, useState } from 'react';
import * as ReactDOM from 'react-dom';
import './MapStyles.scss';
import notificationDecorator from '../../../modules/Notifications/notificationDecorator';

export const useYandexMap = (initial = {}, callback = () => {}) => {
  const [loaded, setLoaded] = useState(false);
  const init = () => {
    if (window.ymaps3) {
      Promise.all([
        window.ymaps3.import('@yandex/ymaps3-controls@0.0.1'),
        window.ymaps3.import('@yandex/ymaps3-reactify'),
        window.ymaps3.import('@yandex/ymaps3-clusterer@0.0.1'),
        // window.ymaps3.import('@yandex/ymaps3-utils'),
        window.ymaps3.ready,
      ]).then(response => {
        const [
          ymaps3Control,
          ymaps3React,
          ymaps3Clusterer,
          ymaps3Utils,
        ] = response;
        window.ymaps3React = ymaps3React;
        window.ymaps3Control = ymaps3Control;
        window.ymaps3Clusterer = ymaps3Clusterer;
        // window.ymaps3Utils = ymaps3Utils;
        setLoaded(true);
      });
    } else {
      notificationDecorator({
        title: 'Загрузка карты',
        message: 'При загрузке карты произошла ошибка',
        isError: true,
      });
    }
  };
  useEffect(() => {
    if (!window.ymaps3React) {
      init();
    } else {
      setLoaded(true);
    }
  }, [window.ymaps3React]);

  if (loaded) {
    const reactify = window.ymaps3React.reactify.bindTo(React, ReactDOM);
    const {
      YMap,
      YMapDefaultSchemeLayer,
      YMapControls,
      YMapListener,
      YMapDefaultFeaturesLayer,
      YMapMarker,
      YMapFeatureDataSource,
      YMapLayer,
      YMapControlButton,
    } = reactify.module(window.ymaps3);
    const {
      YMapZoomControl,
    } = reactify.module(window.ymaps3Control);
    const {
      YMapClusterer,
      clusterByGrid,
    } = reactify.module(window.ymaps3Clusterer);
    window.yandexMap = {
      YMap,
      YMapDefaultSchemeLayer,
      YMapControls,
      YMapListener,
      YMapZoomControl,
      YMapControlButton,
      YMapDefaultFeaturesLayer,
      YMapMarker,
      YMapClusterer,
      clusterByGrid,
      YMapFeatureDataSource,
      YMapLayer,
    };
    return window.yandexMap;
  }
  return null;
};
